/**
 * Validation constants for forms and inputs across the application
 */

export const VALIDATION = {
	CONCEPT_NAME_MAX_LENGTH: 100,
	CONCEPT_NAME_MIN_LENGTH: 1,
	PLAYBOOK_NAME_MAX_LENGTH: 200,
	PLAYBOOK_NAME_MIN_LENGTH: 1,
	DESCRIPTION_MAX_LENGTH: 1000,
} as const

export const VALIDATION_MESSAGES = {
	CONCEPT_NAME_REQUIRED: 'Concept name is required',
	CONCEPT_NAME_TOO_LONG: `Name must be ${VALIDATION.CONCEPT_NAME_MAX_LENGTH} characters or less`,
	PLAYBOOK_NAME_REQUIRED: 'Playbook name is required',
	PLAYBOOK_NAME_TOO_LONG: `Name must be ${VALIDATION.PLAYBOOK_NAME_MAX_LENGTH} characters or less`,
} as const
